<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Pencarian
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <!-- <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Satuan Kerja</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            class="w-100 mb-1"
            v-model="dataFilter.satkerId"
            :options="satkerOptions"
            :reduce="val => val.value"
            @input="(val) => satkerFilter()"
          />
        </b-col> -->
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Periode</label>
          <flat-pickr
            v-model="dataFilter.periode"
            :config="{ mode: 'range'}"
            class="form-control flat-picker bg-transparent border-1 shadow-none"
            placeholder="YYYY-MM-DD to YYYY-MM-DD"
            @input="(val) => satkerFilter()"
          />
        </b-col>
        <!-- <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Kanwil</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="kanwilFilter"
            :options="kanwilOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => changeUPT(val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>UPT</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="uptFilter"
            :options="uptOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:uptFilter', val)"
          />
        </b-col>
         <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Jenis Aset</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="jenisAssetFilter"
            :options="jenisAssetOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:jenisAssetFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status Aset</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusAssetFilter"
            :options="statusAssetOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusAssetFilter', val)"
          />
        </b-col> -->
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    // vSelect,
    flatPickr,
  },
  data() {
    return {
      satker: {},
    }
  },
  props: {
    dataFilter: {},
    satkerOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    satkerFilter() {
      // console.log(this.dataFilter)
      this.$emit('emitFilter', this.dataFilter)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
